{
  "min": -600,
  "max": 100,
  "R": [0, 134, 255],
  "G": [0, 109, 250],
  "B": [0, 101, 245],
  "A": [0, 60, 148],
  "I": [0, 128, 255]
}
